var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuatemala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C31.0456 40 39.9999 31.0457 39.9999 20C39.9999 8.95429 31.0456 -1.52588e-05 19.9999 -1.52588e-05C8.95418 -1.52588e-05 -0.00012207 8.95429 -0.00012207 20C-0.00012207 31.0457 8.95418 40 19.9999 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 19.9998C39.9999 12.0706 35.3855 5.21938 28.6956 1.98438V38.0152C35.3855 34.7803 39.9999 27.929 39.9999 19.9998V19.9998Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9998C0 27.929 4.61445 34.7803 11.3044 38.0153V1.98438C4.61445 5.21937 0 12.0706 0 19.9998Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2263 23.3818L21.8446 20.0001L25.0636 16.7809L24.9177 15.0808L23.9962 14.1591L19.9999 18.1553L16.0037 14.1591L15.0821 15.0808L14.9362 16.7809L18.1552 20.0001L14.7734 23.3818L16.6181 25.2263L19.9999 21.8447L23.3817 25.2263L25.2263 23.3818Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9189 15.081L23.0743 16.9256C23.8611 17.7124 24.3478 18.7994 24.3478 20C24.3478 22.4012 22.4012 24.3478 20 24.3478C17.5988 24.3478 15.6521 22.4012 15.6521 20C15.6521 18.7994 16.1388 17.7124 16.9256 16.9256L15.081 15.081C13.8221 16.3398 13.0435 18.0789 13.0435 20C13.0435 23.842 16.158 26.9565 19.9999 26.9565C23.8419 26.9565 26.9564 23.8419 26.9564 20C26.9564 18.079 26.1778 16.3398 24.9189 15.081V15.081Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuatemala);
export default __webpack_public_path__ + "static/media/guatemala.e2a30777d4ad9b8535292441b2742efe.svg";
export { ForwardRef as ReactComponent };